import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormSection from '../formSectionNew';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import LabelInput from 'components/sales/Input/labelInput/labelInput';
import { handleValidateObj } from 'constants/objValues/objvalues';
import { Dropdown } from 'react-bootstrap';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import { FormGroup } from 'react-bootstrap';
import { DatePickerInput } from 'rc-datepicker';

const Installation = ({ locationPinCode, pincodeData, handleValue, prefilledData,isApartment,leadType=null,commData,postCorData }) => {
  const [isInputError, setIsInputError] = useState({ pinError: false });
  
  const installationInput = {
    scope_of_civil_work: '',
    installation_charge: '',
    cartage_amount: '',
    installation_start_date: '',
    installation_deadline: '',
    type_of_work: '',
    installation_check: '',
    tag_check: '',
    rental_check: '',
    rental_invoice_number:'',
    is_organized: '',
    civil_scope: '',
    electric_scope: '',
    wiring_scope: '',
    wiring_measurement: '',
    wiring_per_unit_price: '',
    wiring_req_qty: '',
    consumables: 'No',
    consumablesData:[{
      // name: "",
      // name_other: "",
      // make: "",
      // uom: "",
      // sales_qty: "",
      // ops_qty: "",
      // base_unit_price: "",
      // sale_unit_price: "",
      // make_items:[]
      id: "",
      uom: "",
      sales_qty: "",
      ops_qty: "",
      base_unit_price: "",
      sale_unit_price: "",
      remarks: ""
    }]
  };
  const [installationData, setInstallation] = useState(installationInput);
  const [isFocus1, setIsFous1] = useState(true);
  const [scopeOfWork, setScopeOfWork] = useState(null);
  const [installtionCheck, setInstallationCheck] = useState(null);
  const [tagCheck, setTagCheck] = useState(null);
  const [rentalCheck, setRentalCheck] = useState(null);
  const [isSetOrganized, setIsOrganized] = useState(null);
  const [civilScope, setCivilScope] = useState(null);
  const [electricScope, setElectricScope] = useState(null);
  const [installationType, setInstallationType] = useState(null);
  const [wiringScope, setWiringScope] = useState(null);
  const [leadTypeIdVal, setLeadTypeId] = useState('');
  const [commTypeIdVal, setCommTypeId] = useState('');
  const [wiringUom, setWiringUom] = useState(null);
  const [addItem, setAddItem] = useState(1);
  const [masterConsumables, setMasterConsumables] = useState(null);

  useEffect(() => {
    if(commData !== null) { 
      const leadTypeId = commData?.leadSubType;
      const commTypeId = commData?.commercialData?.commercial_type_id;
      setLeadTypeId(leadTypeId);
      setCommTypeId(commTypeId);
    }
  },[commData]);

  const handleAddClick = () => {
    setInstallation(prevState => ({
      ...prevState,
      consumablesData: [
        ...prevState.consumablesData,
        {
          id: "",
          uom: "",
          sales_qty: "",
          ops_qty: "",
          base_unit_price: "",
          sale_unit_price: "",
          remarks: ""
        },
      ],
    }));
  };
  const handleRemoveClick = (index) => {
    setInstallation(prevState => ({
      ...prevState,
      consumablesData: prevState.consumablesData.filter((_, i) => i !== index)
    }));
  };
  
  const handleInput2Value = (val, key, index) => {
    if (val !== undefined && key) {
      setInstallation(prevState => ({
        ...prevState,
        consumablesData: prevState.consumablesData.map((item, i) => {
          if (i !== index) return item;
  
          if (key === 'id') {
            return {
              ...item,
              id: val,
              uom: postCorData?.consumales_items?.all_consumbales?.[val]?.uom || null,
              base_unit_price: postCorData?.consumales_items?.all_consumbales?.[val]?.base_price || null,
            };
          } else if (key === 'sales_qty') {
            return {
              ...item,
              sales_qty: val
            };
          } else if (key === 'sale_unit_price') {
            return {
              ...item,
              sale_unit_price: val
            };
          } else if (key === 'remarks') {
            return {
              ...item,
              remarks: val
            };
          } else if (postCorData?.consumales_items?.all_consumbales?.[val]?.[key] !== undefined) {
            return {
              ...item,
              [key]: postCorData?.consumales_items?.all_consumbales?.[val]?.[key]
            };
          } else {
            return {
              ...item,
              [key]: val
            };
          }
        })
      }));
    }
  };
  

  useEffect(() => {
    if(postCorData !== undefined) { 
      setMasterConsumables(postCorData?.consumales_items?.dropdown);
    }
  },[postCorData]);

  useEffect(() => {
    if (
      prefilledData?.commercial !== undefined &&
      prefilledData?.commercial !== null &&
      prefilledData?.commercial?.scope_of_work!== null &&
      prefilledData?.commercial?.manual_invoice!== null &&
      prefilledData?.commercial?.civil_scope!== null &&
      prefilledData?.commercial?.electric_scope!== null 
    ) {
      const {
        scope_of_work,
        installation_start_date,
        installation_deadline,
        // type_of_work,
        installation_amount,
        cartage_amount,
        manual_invoice,
        is_organized,
        civil_scope,
        electric_scope,
        wiring_scope,
        wiring_uom,
        wiring_per_unit_price,
        wiring_req_qty,
        consumable_required,
        consumable_items
      } = prefilledData?.commercial;


      setTimeout(() => {
        // if (typeof manual_invoice.installation_check !== 'undefined') {
        //   var installation_check = manual_invoice.installation_check;
        // }else{
        //   var installation_check = 'No';
        // }
        let consumable_items_data = [];
        if(consumable_items === null || consumable_items === undefined || consumable_items.length === 0){
          consumable_items_data = [{
            id: "",
            uom: "",
            sales_qty: "",
            ops_qty: "",
            base_unit_price: "",
            sale_unit_price: "",
            remarks: ""
          }]
        }else{
          consumable_items_data = consumable_items.map((item) => ({
            id: item?.id ?? "",
            uom: item?.uom ?? "",
            sales_qty: item?.sales_qty ?? "",
            ops_qty: item?.ops_qty ?? "",
            base_unit_price: item?.base_unit_price ?? "",
            sale_unit_price: item?.sale_unit_price ?? "",
            remarks: item?.remarks ?? "",
            service_name: item?.service_name ?? "",
            service_code: item?.service_code ?? "",
          }));
        }
        setInstallation({
          ...installationData,
          installation_start_date: installation_start_date,
          installation_deadline: installation_deadline,
          installation_charge: installation_amount,
          cartage_amount:cartage_amount,
          // type_of_work: type_of_work,
          scope_of_civil_work: scope_of_work,
          is_organized: is_organized,
          civil_scope: civil_scope,
          electric_scope: electric_scope,
          wiring_scope: wiring_scope,
          wiring_measurement: wiring_uom,
          wiring_per_unit_price: wiring_per_unit_price,
          wiring_req_qty:wiring_req_qty,
          consumables: consumable_required,
          consumablesData: consumable_items_data,
          installation_check: (manual_invoice && manual_invoice.installation_check) ? manual_invoice.installation_check :'No',
          tag_check: (manual_invoice && manual_invoice.tag_check) ? manual_invoice.tag_check :'No',
          rental_check: (manual_invoice && manual_invoice.rental_check) ? manual_invoice.rental_check :'No',
          rental_invoice_number: (manual_invoice && manual_invoice.rental_invoice_number) ? manual_invoice.rental_invoice_number :'',
          
        });
        setIsOrganized(is_organized);
        setInstallationCheck((manual_invoice && manual_invoice.installation_check) ? manual_invoice.installation_check :'No');
        setTagCheck((manual_invoice && manual_invoice.tag_check) ? manual_invoice.tag_check :'No');
        setRentalCheck((manual_invoice && manual_invoice.rental_check) ? manual_invoice.rental_check :'No');
        setScopeOfWork( (scope_of_work == 2)
        ? 'Park +'
        : 'Client'
        );
        setInstallationType(scope_of_work);
        setCivilScope( (civil_scope == 2)
          ? 'Park +'
          : 'Client'
        );
        setElectricScope( (electric_scope == 2)
          ? 'Park +'
          : 'Client'
        );
        setWiringScope(wiring_scope);

      }, 100);
    }
  }, [prefilledData]);

  const handleDateChange1 = (date, dateString) => {
    const selectedDate = dateString;
    setInstallation({
      ...installationData,
      installation_start_date: selectedDate,
    });
    
  };
  const handleDateChange2 = (date, dateString) => {
    const selectedDate = dateString;
    setInstallation({
      ...installationData,
      installation_deadline: selectedDate,
    });
    
  };
 
  
  const handleRentalCheck = (val) =>{
    if(val === 'No'){
      setInstallation({
        ...installationData,
        rental_check:'No',
        rental_invoice_number: '',
      });
    }
    setRentalCheck(val);
  };

  const type_of_work_dd = () =>{
    if(installationData.scope_of_civil_work == 1)
    return (
      <div className='col-md-6'>
        <DropDownInput
          
          label={localization.type}
          data={[
            { id: 'Both', name: 'Both' },
            { id: 'Civil', name: 'Civil Work' },
            { id: 'Wiring', name: 'Wiring' },
          ]}
          required
          errorMsg={localization.type}
          getIdValue={(val) =>{
            setInstallation({
              ...installationData,
              type_of_work: val.id,
            });
          }
          }
          value={installationData.type_of_work !== null ? installationData.type_of_work : null}
          isStarRequired={true}
      />
      </div>
    );
  };


  const handleFormData = () => {
    if (installationData) {
      handleValue({ installationData});
    } else {
      handleValue(null);
    }
  };

  useEffect(() => {
    handleFormData();
  }, [installationData]);
 
  return (
    <FormSection title={localization.installation}>
      <div className='row'>
      <div className='col-md-6'>
    <FormGroup
        className={`date custom_date_picker ${isFocus1 ? 'active-date' : ''}`}
      >
       <label>
          {localization.installationStartDate}
          <span className="label-star" style={{ color: 'red' }}>
            {' '}
            *{' '}
          </span>
        </label>
      <DatePickerInput
          onChange={handleDateChange1}
          // onShow={() => setIsFous1(true)}
          autoClose
          closeOnClickOutside
          showOnInputClick
          locale="en"
          className="my-custom-datepicker-component"
          minDate={new Date()}
          required
          format="DD-MM-YYYY"
          displayFormat="DD-MM-YYYY"
          returnFormat="YYYY-MM-DD"
          value={installationData.installation_start_date !== null ? installationData.installation_start_date : null}
        />
        {!isFocus1 && (
          <label className="error date_error">
            {localization.requiredLastInterdate}
          </label>
        )}
      </FormGroup>
      </div>
      <div className='col-md-6'>
      <FormGroup
        className={`date custom_date_picker ${isFocus1 ? 'active-date' : ''}`}
      >
       <label>
          {localization.installationDeadline}
          <span className="label-star" style={{ color: 'red' }}>
            {' '}
            *{' '}
          </span>
        </label>
      <DatePickerInput
          onChange={handleDateChange2}
          // onShow={() => setIsFous1(true)}
          autoClose
          closeOnClickOutside
          showOnInputClick
          locale="en"
          className="my-custom-datepicker-component"
          minDate={new Date()}
          required
          format="DD-MM-YYYY"
          displayFormat="DD-MM-YYYY"
          returnFormat="YYYY-MM-DD"
          value={installationData.installation_deadline !== null ? installationData.installation_deadline : null}
        />
        {!isFocus1 && (
          <label className="error date_error">
            {localization.installationDeadline}
          </label>
        )}
      </FormGroup>
      </div>
      </div>
      {/* <hr/> */}
    <div className='row'>
     {leadType === 4 ? (
      <div className='col-md-6'>
          <DropDownInput 
            label={localization.isOrganized}
            data={[
              { id: 'Organized', name: 'Organized' },
              { id: 'Unorganized', name: 'Unorganized' },
            ]}
            required
            errorMsg={localization.isOrganizedRequired}
            getIdValue={(val) =>{
              setInstallation({
                ...installationData,
                is_organized: val.id,
              });
            }
            }
            value={isSetOrganized !== null ? isSetOrganized: ''}
            isStarRequired={true}
        />
      </div>
     ):null}
      <div className='col-md-6'>
        <DropDownInput
          
          label={localization.scopeOfCivilWork}
          data={[
            { id: '1', name: 'Client' },
            { id: '2', name: 'Park +' },
          ]}
          required
          errorMsg={localization.requiredScope}
          getIdValue={(val) =>{
            setInstallation({
              ...installationData,
              scope_of_civil_work: val.id,
            });
            if(val.id == 1){
              setInstallation(prevState => ({
                ...prevState,
                consumables: 'No',
              }));
            }
            setInstallationType(val.id);
          }
          }
          value={scopeOfWork !== null ? scopeOfWork : ''}
          isStarRequired={true}
      />
      </div>
    {/*{type_of_work_dd()}*/}
    {installationType==2 ? 
      <div className='col-md-6'>
      <ConstantInput
        label={localization.installationCharge}
        className="indianrupee"
        isPrefix
        prefixText={'₹'}
        type="number"
        // value={locationData.billGeoState}
        handleChange={(val) => {
          setInstallation({
            ...installationData,
            installation_charge: val,
          });
        }}
        value={installationData.installation_charge}
      />
      </div>
    : null}
    
      <div className='col-md-6'>
      <ConstantInput
        label={localization.cartage_amount}
        className="indianrupee"
        isPrefix
        prefixText={'₹'}
        type="number"
        // value={locationData.billGeoState}
        handleChange={(val) => {
          setInstallation({
            ...installationData,
            cartage_amount: val,
          });
        }}
        value={installationData.cartage_amount}
      />
      </div>
      
      {/* <ConstantInput
        label={localization.installationDeadline}
        // value={locationData.billGeoState}
        handleChange={(val) => {
          setInstallation({
            ...installationData,
            installation_deadline: val,
          });
        }}
      /> */}
  
      <div className='col-md-6'>
        <DropDownInput

          label={localization.civilScope}
          data={[
            { id: '1', name: 'Client' },
            { id: '2', name: 'Park +' },
          ]}
          required
          errorMsg={localization.requiredScope}
          getIdValue={(val) =>{
            setInstallation({
              ...installationData,
              civil_scope: val.id,
            });
          }
          }
          value={civilScope !== null ? civilScope : ''}
          isStarRequired={true}
        />
      </div>

      <div className='col-md-6'>
        <DropDownInput

          label={localization.electricalScope}
          data={[
            { id: '1', name: 'Client' },
            { id: '2', name: 'Park +' },
          ]}
          required
          errorMsg={localization.requiredScope}
          getIdValue={(val) =>{
            setInstallation({
              ...installationData,
              electric_scope: val.id,
            });
          }
          }
          value={electricScope !== null ? electricScope : ''}
          isStarRequired={true}
        />
      </div>
      {commTypeIdVal === 5 && installationType==2 &&
      <>
      <div className='col-md-6'>
      <DropDownInput
          
          label={localization.consumables}
          data={[
            { id: 'Yes', name: 'Yes' },
            { id: 'No', name: 'No' },
          ]}
          required
          errorMsg={localization.requiredScope}
          getIdValue={(val) =>{
            setInstallation({
              ...installationData,
              consumables: val.id,
            });
            setWiringScope(val.id);
          }
          }
          value={installationData?.consumables != '' ? installationData?.consumables : 'No'}
          isStarRequired={true}
      />
      </div>
      {installationData?.consumables === 'Yes' && 
        <div className="col-md-12">
        {addItem === 1 ? (
          <>
            {installationData?.consumablesData?.length > 0 && installationData?.consumablesData.map((x, i) => {
              return (
                <div key={'k_' + i}>
                  <div className="row">
                  <div className="col-md-3 col-sm-12">
                      {/* <ConstantInput
                        label={localization.hsn}
                        type="text"
                        required={true}
                        isStarRequired={true}
                        errorMsg={localization.isRequired}
                        handleChange={(val) => {
                          handleInput2Value(val, "hsn_code", i);
                        }}
                        value={x?.name}
                      /> */}
                      <DropDownInput
                        label={localization.consumables}
                        data={masterConsumables}
                        required
                        errorMsg={localization.requiredScope}
                        getIdValue={(val) => {
                          handleInput2Value(val.id, "id", i);
                        }}
                        value={x?.service_name ?? postCorData?.consumales_items?.all_consumbales?.[x?.id]?.['service_name'] ?? ''}
                        isStarRequired={true}
                      />
                    </div>
                    <div className="col-md-3 col-sm-12">
                      <ConstantInput
                        label={localization.uom}
                        type="text"
                        required
                        isStarRequired={true}
                        value={x?.uom}
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-3 col-sm-12">
                      <ConstantInput
                        label={localization.requiredQty}
                        className=""
                        type="number"
                        required
                        isStarRequired={true}
                        handleChange={(val) => {
                          handleInput2Value(val, "sales_qty", i);
                        }}
                        value={x?.sales_qty}
                        disabled={(x?.scope && x?.scope == 1) ? true : false}
                      />
                    </div>
                    <div className="col-md-3 col-sm-12">
                      <ConstantInput
                        label={`Base Unit Price`}
                        className="indianrupee"
                        isPrefix
                        prefixText={'₹'}
                        type="number"
                        handleChange={(val) => {
                          handleInput2Value(val, "base_unit_price", i);
                        }}
                        value={x?.base_unit_price}
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-3 col-sm-12">
                      <ConstantInput
                        label={`Sale Unit Price`}
                        className="indianrupee"
                        isPrefix
                        prefixText={'₹'}
                        type="number"
                        required
                        isStarRequired={true}
                        handleChange={(val) => {
                          handleInput2Value(val, "sale_unit_price", i);
                        }}
                        value={x?.sale_unit_price}
                        // disabled={true}
                      />
                    </div>
                    <div className="col-md-3 col-sm-12">
                      <ConstantInput
                        label={`Total Price`}
                        className="indianrupee"
                        isPrefix
                        prefixText={'₹'}
                        type="number"
                        required
                        isStarRequired={true}
                        value={parseFloat(x?.sale_unit_price * x?.sales_qty)}
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-3 col-sm-12">
                      <ConstantInput
                        label={`Specification`}
                        className=""
                        type="text"
                        handleChange={(val) => {
                          handleInput2Value(val, "remarks", i);
                        }}
                        value={x?.remarks}
                      />
                    </div>
                    <div className="col-md-3 col-sm-12 d-flex">
                      {installationData?.consumablesData.length !== 1 && (
                        <div className="col-md-2 col-sm-5">
                          <button
                            onClick={() => handleRemoveClick(i)}
                            className="mr10 btn btn-sm btn-danger"
                          >
                            Remove
                          </button>
                        </div>
                      )}
                      {installationData?.consumablesData.length - 1 === i && (
                        <div className="col-md-2 col-sm-5">
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={handleAddClick}
                          >
                            Add
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        ) : addItem === 2 ? (
          {}
        ) : null}
      </div>
      }
      </>
      }
      </div>
      {/* <hr/> */}
      {isApartment && postCorData?.commercialData?.commercial_type_id !== 5 ?
       <div className='row'>
        <div className='col-md-12'><h5>Is Manual Invoice required? : <small>Select Yes If you want to add manual invoice</small></h5>
        <br/>
        </div>
        <div className='col-md-3'>
        <DropDownInput
                  label="Installation Invoice"
                  data={[
                    {
                      id: "Yes",
                      name: "Yes",
                    },
                    {
                      id: "No",
                      name: "No",
                    },
                  ]}
                  required
                  getIdValue={(val) =>{
                    setInstallation({
                      ...installationData,
                      installation_check: val.id,
                    });
                  }
                  }
                  value={installtionCheck !== null ? installtionCheck : ''}
                  
                  isStarRequired={true}
                />
        </div>
        <div className='col-md-3'>
        <DropDownInput
                  label="Tag Invoice"
                  data={[
                    {
                      id: "Yes",
                      name: "Yes",
                    },
                    {
                      id: "No",
                      name: "No",
                    },
                  ]}
                  required
                  getIdValue={(val) =>{
                    setInstallation({
                      ...installationData,
                      tag_check: val.id,
                    });
                  }
                  }
                  value={tagCheck !== null ? tagCheck : ''}
                  
                  isStarRequired={true}
                />
        </div>
        <div className='col-md-3'>
        <DropDownInput
                  label="Rental/Capex Invoice"
                  data={[
                    {
                      id: "Yes",
                      name: "Yes",
                    },
                    {
                      id: "No",
                      name: "No",
                    },
                  ]}
                  required
                  getIdValue={(val) =>{
                    setInstallation({
                      ...installationData,
                      rental_check: val.id,
                    });
                    handleRentalCheck(val.id);
                  }
                  }
                  value={rentalCheck !== null ? rentalCheck : ''}
                  
                  isStarRequired={true}
                />
        </div>
        {rentalCheck && rentalCheck==='Yes'?
            <div className='col-md-3'>
            <ConstantInput
              label={`Invoice Number`}
              
              type="text"
              // value={locationData.billGeoState}
              handleChange={(val) => {
                setInstallation({
                  ...installationData,
                  rental_invoice_number: val,
                });
              }}
              value={installationData.rental_invoice_number}
          />
        </div>
        :null}
        
      </div>
       :
        null}
     
    </FormSection>
  );
};

Installation.propTypes = {
  locationPinCode: PropTypes.func,
  pincodeData: PropTypes.any,
  handleValue: PropTypes.func,
};

export default Installation;
